import { put, select, all, takeEvery, call, fork } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import Cookies from 'universal-cookie';
import { setCookie } from 'isomorphic-redux-cookie-middleware';
import { getDomainSelector } from 'common/selectors/location';
import type { Action } from 'redux';
import { ShoppingListItem } from './types';
import { SHOPPING_LIST_COOKIE_KEY } from 'common/constants';
import { parseShoppingListCookie } from './utils';

export const ADD_TO_SHOPPING_LIST_REQUEST = createAction('products/ADD_TO_SHOPPING_LIST_REQUEST')<string>();
export const REMOVE_FROM_SHOPPING_LIST_REQUEST = createAction(
  'products/REMOVE_FROM_SHOPPING_LIST_REQUEST',
)<string>();

export function* writeShoppingListCookie(items: ShoppingListItem[]) {
  const domain: string = yield select(getDomainSelector);

  const cookieValue = items.map((item) => `${item.id}:${item.quantity}`).join(';');

  yield put(
    setCookie(SHOPPING_LIST_COOKIE_KEY, cookieValue, {
      domain,
      path: '/',
      expires: new Date(new Date().getFullYear() + 1, 12, 31),
    }) as Action,
  );
}

export function* addToShoppingList({ payload }: { payload: string }) {
  const cookies = new Cookies();
  const cookieValue = cookies.get(SHOPPING_LIST_COOKIE_KEY);
  const current = parseShoppingListCookie(cookieValue);

  const existingItem = current.find((item) => item.id === payload);

  if (!existingItem) {
    const updated = [...current, { id: payload, quantity: 1 }];
    yield call(writeShoppingListCookie, updated);
  }
}

export function* removeFromShoppingList({ payload }: { payload: string }) {
  const cookies = new Cookies();
  const cookieValue = cookies.get(SHOPPING_LIST_COOKIE_KEY);
  const current = parseShoppingListCookie(cookieValue);

  const filteredItems = current.filter((item) => item.id !== payload);
  yield call(writeShoppingListCookie, filteredItems);
}

function* watchShoppingList() {
  yield takeEvery(ADD_TO_SHOPPING_LIST_REQUEST, addToShoppingList);
  yield takeEvery(REMOVE_FROM_SHOPPING_LIST_REQUEST, removeFromShoppingList);
}

export function* rootSaga() {
  yield all([fork(watchShoppingList)]);
}
